import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzSelectModule } from 'ng-zorro-antd/select';
import { CloseDropdownOnScrollModule } from '../../directives/close-dropdown-on-scroll/close-dropdown-on-scroll.module';

import { TimezoneComponent } from './timezone.component';

@NgModule({
  declarations: [TimezoneComponent],
  exports: [TimezoneComponent],
  imports: [
    CommonModule,
    NzSelectModule,
    CloseDropdownOnScrollModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class TimezoneModule { }
